module.exports = __webpack_public_path__ + "img/1(3).25cc2978.png";